import request from '@/utils/request';
//查询礼品列表
export function getQueryGiftPage(param) {
  return request('/activityPoints/queryGiftPage', {
    method: 'POST',
    data: param,
  });
}

//校验删除礼品
export const canDeleteGift = (data) => {
  return request('/activityPoints/queryGiftExchange', {
    method: 'POST',
    data,
  });
};

//删除礼品
export const deleteGift = (data) => {
  return request('/activityPoints/deleteGift', {
    method: 'POST',
    data,
  });
};
